import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { Box, Button, Paper, TextField, Checkbox } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import { useCookies } from "react-cookie";
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AppHeader from "../component/AppHeader";
import api from "../../API";
import SampleListPage from "./dialog/SampleListPage";
import DialogUploadPage from "./dialog/DialogUploadPage";
import DocumentUploadPage from "../nki/document/DocumentUploadPage";
import ConfirmListPage from "./ConfirmListPage_bak";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import VolumeMuteSharpIcon from '@mui/icons-material/VolumeMuteSharp';
import GroupIcon from '@mui/icons-material/Group';
import NoiseAwareIcon from '@mui/icons-material/NoiseAware';


interface IFileTypes {
  id: number;
  object: File;
}

const SamplePage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const user_state = useSelector((state:any)=> state.userInfo.data.user.state)
  
  console.log('샘플 페이지 user_state' , user_state) // sample_upload

  const [sampleType, setSampleType] = useState('')

  // console.log('샘플페이지 사용자 권한 확인', auth , auth.user.roles.filter((obj:any) => obj.role === 'NKI'))

  // const sample_confirm = auth.user.roles.some((obj:any) => obj.use_yn === 'sample_confirm')

  // console.log('샘플 페이지 ??? ', auth.user.roles)

  const [samples, setSamples] = useState<IFileTypes[]>([]);
  
  const [sampleListPage, setSampleListPage] = useState(false)

  const sampleUploadList = async () => {
    api.get('/sampleList',{params:{email:email}})
    .then((res:any) => {console.log("업로드 리스트 ", res.data.datas); setSamples(res.data.datas); })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const getAuth = async () => {
    console.log('SamplePage /@me 이메일', email)
    if(!email){
      nav('/')
    }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const steps = [
    '샘플제출단계',
    '계약정보 입력단계',
    '본작업 수집데이터 제출단계',
  ];
  
  useEffect(() => {
    getAuth()
    sampleUploadList()
  },[])

  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 38,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(33, 242, 43) 0%,rgb(44, 165, 60) 50%,rgb(59, 83, 190) 100%)',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(33, 242, 43) 0%,rgb(44, 165, 60) 50%,rgb(59, 83, 190) 100%)',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 5,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));

  const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    display: 'flex',
    width: 80,
    height: 80,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex:1,
    ...(ownerState.active && {
      backgroundImage:
        'linear-gradient( 136deg, rgb(64, 95, 233) 0%, rgb(64, 95, 233) 50%, rgb(64, 95, 233) 100%)'
    }),
    ...(ownerState.completed && {
      backgroundImage:
        'linear-gradient( 136deg, #ffffff 0%, rgb(33, 242, 43) 50%, rgb(33, 242, 43) 100%)'
    }),
  }));

  function ColorlibStepIcon(props: any) {
    const { active, completed, className } = props;
  
    const icons: { [index: string]: React.ReactElement } = {
      1: <img style={{width:"60px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/report.png'} />,
      2: <img style={{width:"50px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/project.png'} />,
      3:<img style={{width:"52px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/upload.png'} />,
    };
  
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }



  return (

    <Box>
      <Box sx={{ display:"flex", justifyContent:"center", width:"100%",fontSize: "100px", fontWeight: 600, backgroundColor: "#fff", height: "500%", maxWidth: "100%", marginTop:"50px"}}>
      <Stepper activeStep={(user_state == 'sample_upload' ? 0 : (user_state == 'sample_confirm' ? 1 : 2))} alternativeLabel connector={<ColorlibConnector />}>
        {steps.map((label) => (
          <Step key={label} >
            <StepLabel StepIconComponent={ColorlibStepIcon} sx={{marginLeft:"40px",marginRight:"40px",fontWeight:600}}><Box sx={{fontSize:"20px",fontWeight:600}}>{label}</Box></StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
    <Box>

        {/* <AppHeader /> */}

        {/* <Box sx={{display:"flex" , justifyContent: "center", marginTop:"50px"}}>

        <Box sx= {{width: "150px", fontSize: "50px", fontWeight: 600, backgroundColor:"#81d4fa", color: "#fff",marginLeft:"2px", marginRight:"13px",textAlign:"center"}}>샘플</Box>
        <ArrowForwardIcon sx= {{size: "larg",justifyContent: "center",display:"flex",marginTop:"20px",marginLeft:"2px", marginRight:"20px"}}></ArrowForwardIcon>

        <Box sx= {{width: "250px", fontSize: "50px", fontWeight: 600, backgroundColor:"#81d4fa", color: "#fff",marginLeft:"2px", marginRight:"20px",textAlign:"center"}}>계약정보</Box>
        <ArrowForwardIcon sx= {{size: "larg",justifyContent: "center",display:"flex",marginTop:"20px",marginLeft:"2px", marginRight:"20px"}}></ArrowForwardIcon>

        <Box sx= {{width: "150px", fontSize: "50px", fontWeight: 600, backgroundColor:"#81d4fa", color: "#fff",marginLeft:"2px", marginRight:"20px", textAlign:"center"}}>수집</Box>
        </Box> */}

      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        <Box sx={{display:(sampleType == '' ? "flex" : "none") , justifyContent: "center", marginTop:"100px"}}>
          
          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#404ec7", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleType('dialog')}>
            대화
          <GroupIcon sx={{fontSize:"100px", color:"#fff",justifyContent: "center" }}></GroupIcon>
          </Button>
          
          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#23962d", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleType('sound')}>
            소리 
          <VolumeMuteSharpIcon sx={{fontSize:"120px", color:"#fff",justifyContent: "center" }}></VolumeMuteSharpIcon>
          </Button>
          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"20px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#df8e43", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleType('noise')}>
            소음
          <NoiseAwareIcon sx={{fontSize:"100px", color:"#fff",justifyContent: "center" }}></NoiseAwareIcon>
          </Button>
        </Box>

        {/* <Box sx={{display:"flex" , justifyContent: "center", marginTop:"50px"}}>
          <Button sx={{width: "230px", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>제출현황 페이지</>: <>업로드 페이지</>}</Button>
          <Button sx={{width: "230px", fontSize: "24px", marginRight:"20px", marginLeft:"50px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>업로드 페이지</>: <>제출현황 페이지</>}</Button>
        </Box> */}

        {/* 2023-09-08 오후부터 추가 샘플 제출은 마감되었습니다. */}
        <Box sx={{display:(sampleType == 'dialog' ? "flex" : "none") , justifyContent: "center", marginTop:"100px"}}>
          {/* {samples.length > 0 ? <SampleListPage samples={samples} /> : <img style={{width:"50%"}} src={process.env.PUBLIC_URL + "/img/20230908_음성녹음클라우드일정공지.jpg"} />} */}
          {/* {samples.length > 0 ? <DialogUploadPage sampleUploadList={sampleUploadList} /> : ""} */}
          {samples.length > 0 ? <SampleListPage samples={samples} /> : ""}
          <DialogUploadPage sampleUploadList={sampleUploadList} />
        </Box>
        <Box sx={{display:(sampleType == 'sound' ? "flex" : "none") , justifyContent: "center", marginTop:"100px"}}>
          소리 업로드 기능 개발 중
        </Box>
        <Box sx={{display:(sampleType == 'noise' ? "flex" : "none") , justifyContent: "center", marginTop:"100px"}}>
          소음 업로드 기능 개발 중
        </Box>

        {/* <Box sx={{display: 'none', justifyContent: "center", padding:"72px"}}>
            {sampleListPage ?
              <SampleListPage samples={samples} />
            :
              (user_state === 'sample_upload' ?
                // 샘플 파일 업로드
                <SampleUploadPage sampleUploadList={sampleUploadList} />  
                :
                // 문서 제출
                <ConfirmListPage samples={samples} sampleUploadList={sampleUploadList}  />
              )
            }

        </Box> */}
      </Box>
    </Box>
    </Box>
  );
};

export default SamplePage;
